import {observer} from 'mobx-react-lite';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useMountEffect} from 'webapp-lib/utils';

import loading from '_/assets/images/loading.svg';

import {StyledLoading} from './styles';

export interface Props {
  className?: string;
  ref?: React.Ref<HTMLDivElement>;
  noDelay?: boolean;
}

export function LoadingComponent({
  className,
  noDelay,
  ref,
}: Props): React.ReactElement {
  const {t} = useTranslation('common');

  const [showLoader, setShowLoader] = useState(noDelay || false);

  useMountEffect(() => {
    const timerId = setTimeout(setShowLoader, 500, true);

    return (): void => window.clearTimeout(timerId);
  });

  return (
    <StyledLoading
      ref={ref}
      className={className}
      data-testid='loading'
      title={t('loading')}
    >
      {showLoader && (
        <object
          data={loading}
          // Height matches the Loading icon's height. It is necessary here
          // to avoid reflow after the image finished loading.
          height={80}
          tabIndex={-1}
          type='image/svg+xml'
          width={80}
        >
          {t('loading')}
        </object>
      )}
    </StyledLoading>
  );
}

export default observer(LoadingComponent);
